var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZenToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z",
    fill: "url(#paint0_radial_9825_44901)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#3C97FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5697 11.3203C15.1307 9.38205 14.3956 7.21567 12.6096 6.05124C11.2355 5.14696 9.58774 5.04168 8.17022 5.63152C8.08088 5.66869 7.96502 5.6379 7.90089 5.56561C7.78446 5.43437 7.83777 5.23391 8.00017 5.16691C9.54934 4.52782 11.3629 4.64839 12.872 5.63835C14.8626 6.94227 15.6724 9.3671 15.0082 11.5277C15.6508 11.989 15.8146 12.8612 15.3826 13.5218C14.9283 14.1955 14.0335 14.3742 13.359 13.9343C12.6844 13.4806 12.5055 12.587 12.946 11.9133C13.3048 11.3757 13.9651 11.1483 14.5697 11.3203ZM12.0188 14.8239C12.1732 14.7592 12.2093 14.5589 12.1018 14.4309C12.0339 14.35 11.925 14.3305 11.8273 14.3708C10.4125 14.9535 8.75928 14.852 7.39046 13.9512C5.59669 12.7817 4.86297 10.6107 5.43785 8.66182C6.03175 8.82947 6.68685 8.60832 7.05408 8.06375C7.50836 7.39008 7.31564 6.49644 6.6411 6.04275C5.96656 5.60281 5.07176 5.79528 4.61748 6.4552C4.18404 7.11804 4.35033 7.99384 4.99833 8.45399C4.32245 10.6198 5.13112 13.056 7.12812 14.3641C8.64514 15.3593 10.4649 15.4746 12.0188 14.8239Z",
    fill: "#3C97FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9825_44901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.91485 4.08667) rotate(57.8639) scale(16.1725 16.1447)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.340963,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECEC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZenToken);
export default __webpack_public_path__ + "static/media/zen_token.882eacbd0672357fc085645aa08c7682.svg";
export { ForwardRef as ReactComponent };